import { Schema, Dimension } from './schema.model';
import { Query } from './query.model';
import { Slice } from './query_result.model';

class Row {
  constructor(readonly slices: Slice[]) {}
}

export class SlicesResult {
  readonly schema: Schema
  readonly dimensions: Dimension[]
  readonly rows: Row[]
  readonly nextSlice: any
  readonly limit: number

  constructor(readonly query: Query, private rawQueryResult) {
    this.schema = query.schema
    this.dimensions = this.parseDimensions(rawQueryResult['cube'])

    this.limit = rawQueryResult['limit']
    this.nextSlice = rawQueryResult['next_slice']

    const rawSlices = rawQueryResult['slices']
    this.rows = this.parseRows(rawSlices)
  }

  getSlices(dimension: Dimension) {
    const index = this.dimensions.findIndex(d => d.name === dimension.name)
    return this.rows.map(row => row.slices[index]).unique(s => s.value)
  }

  private parseRows(rawSeries) {
    return rawSeries.map(raw => {
      const slices = this.parseSlices(raw)
      return new Row(slices)
    }).flatten()
  }

  private parseDimensions(rawDimensions) {
    return rawDimensions.map(dimensionName => {
      const schemaDimension = this.schema.fetchDimension(dimensionName)
      return new Dimension(dimensionName, schemaDimension.meta, null)
    })
  }

  private parseSlices(rawRow) {
    const rawSlice = rawRow['slice']
    const rawData = rawRow['data'] || {}
    return this.dimensions.map(dimension => {
      const dimName = dimension.name
      const value = rawSlice[dimName]
      const data = rawData[dimName]
      return new Slice(dimension, value, data)
    })
  }

  isLimited() {
    return !!this.nextSlice
  }
}
